import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'

/**
 * a wrapper for Mix Design Number
 *
 * @param help
 * @param priority
 */
export function useMixDesignNumberColumn<
  T extends { mixDesignNumber?: string | null }
>(help: string): CIMSColumn<T> {
  return {
    title: 'Mix Design Number',
    render: 'mixDesignNumber',
    help,
    width: 220,
    sort: {
      with: 'key',
      key: 'mixDesignNumber',
      default: 'ascend',
      priority: 2,
    },
    filter: {
      type: 'search',
      with: 'key',
      key: 'mixDesignNumber',
    },
  } as CIMSColumn<T>
}
